import React from 'react';
import classNames from 'classnames';
import styles from './index.module.scss';

type FooterProps = {
  children?: React.ReactNode;
  'data-test-id'?: string;
  position?: 'left' | 'right';
  className?: string;
};

function Footer({
  children,
  'data-test-id': dataTestId,
  position = 'right',
  className,
}: React.PropsWithChildren<FooterProps>) {
  return (
    <div
      data-test-id={`${dataTestId}`}
      className={classNames(
        styles.page__footer,
        className,
        styles[`${position}`],
      )}
    >
      {children}
    </div>
  );
}

export default Footer;
